export const handlePhoneClick = (val?: string) => {
	if (!val) return;
	window.open(`tel:${val}`, "_blank");
};

export const handleSmsClick = (val?: string) => {
	if (!val) return;
	window.open(`sms:${val}`, "_blank");
};

export const handleEmailClick = (val?: string) => {
	if (!val) return;
	window.open(`mailto:${val}`, "_blank");
};
